module.exports = __webpack_public_path__ + "favicon.ico?fe8f752a542526fa2421a40ebeb02332";